// 文字 / 语音两模式共用的打断按钮:红色圆钮 + 白色停止方块。两模式同尺寸(h-12),不再分大小。
export function InterruptButton({ onClick }: { onClick: () => void }) {
    return (
        <button
            onClick={onClick}
            aria-label="打断"
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-destructive text-white transition active:scale-95"
        >
            <span className="h-[17px] w-[17px] rounded-[4px] bg-white" />
        </button>
    )
}
